import { Star } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { REVIEWS } from "./data";

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={`star-${n}`} size={14} className="fill-edge text-edge" />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section className="relative bg-coal py-24 lg:py-32" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mb-14 flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Eyebrow>Google Reviews</Eyebrow>
            <SectionTitle>
              What Our <span className="text-edge">Customers Say</span>
            </SectionTitle>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-dim">
            Real reviews from our Google Business profile
          </p>
        </Reveal>

        <div className="columns-1 gap-6 md:columns-2 lg:columns-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={(i % 3) * 0.07} className="mb-6 break-inside-avoid">
              <figure
                className="clip-corner-sm border border-line bg-card p-7 transition-colors duration-300 hover:border-edge/50"
                data-testid={`review-card-${i + 1}`}
              >
                <Stars />
                <blockquote className="mt-4 leading-relaxed text-white/90">
                  &ldquo;{r.text}&rdquo;
                </blockquote>
                <figcaption className="mt-5 flex items-center justify-between border-t border-line pt-4">
                  <span className="font-display text-lg font-bold uppercase tracking-wide text-white">
                    {r.name}
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
                    {r.time}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
